const updateState = (obj, key, value) => ({ ...obj, [`${key}`]: value })

export const filterReducer = (state, action) => {
    switch (action.type) {
        case "budget": return updateState(state, "budget", Number(action.payload))
        case "name": return updateState(state, "name", RegExp(action.payload))
        default: return state
    }
}